import { DncBooleanValueMap, DncScopeEnum } from './dnc-field-mapping-enums';
import type { DncScopeValue } from './dnc-field-mapping-enums';

export const parseDncBoolean = (
  value: string | undefined | null,
): boolean | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const normalizedValue = value.toString().toLowerCase().trim();

  if (normalizedValue in DncBooleanValueMap) {
    return DncBooleanValueMap[
      normalizedValue as keyof typeof DncBooleanValueMap
    ];
  }

  return undefined;
};

const SCOPE_VALUE_MAP = {
  company: DncScopeEnum.Company,
  uv: DncScopeEnum.Company,
  universal: DncScopeEnum.Company,
  ever: DncScopeEnum.Company,
  powerdialer: DncScopeEnum.Powerdialer,
  campaigns: DncScopeEnum.Powerdialer,
  campaign: DncScopeEnum.Powerdialer,
  pd: DncScopeEnum.Powerdialer,
} as const;

export const parseDncScope = (
  value: string | undefined | null,
): DncScopeValue | undefined => {
  if (value === null || value === undefined) {
    return DncScopeEnum.Powerdialer;
  }

  const normalizedValue = value.toString().toLowerCase().trim();

  return (
    (SCOPE_VALUE_MAP as Record<string, DncScopeValue | undefined>)[
      normalizedValue
    ] ?? DncScopeEnum.Powerdialer
  );
};

export const validateE164PhoneNumber = (phoneNumber: string): boolean => {
  const e164Regex = /^\+[1-9]\d{1,14}$/;
  return e164Regex.test(phoneNumber);
};

export const normalizeToE164 = (
  phoneNumber: string,
  defaultCountryCode = '1',
): string | null => {
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  if (digitsOnly.length >= 11) {
    return `+${digitsOnly}`;
  }

  if (digitsOnly.length === 10) {
    return `+${defaultCountryCode}${digitsOnly}`;
  }

  return null;
};
